import type * as Immutable from 'immutable';
import { createMigration } from './utils';

/**
 * Sets isEditable to true for ColorAssets where isColorEditable is already true
 */
function setIsEditableForColorAsset(
    map: Immutable.Map<string, unknown>,
    path: Array<string | number>,
) {
    const asset = map.getIn(path) as Immutable.Map<string, unknown> | undefined;
    if (!asset) {
        return;
    }

    const classType = asset.get('classType');
    if (classType !== 'ColorAsset') {
        return;
    }

    const isColorEditable = asset.get('isColorEditable');
    if (!isColorEditable) {
        return;
    }

    map.setIn([...path, 'isEditable'], true);
}

export const migrationTo9_231 = createMigration({
    migrateVideo(video) {
        return video.withMutations((map) => {
            map.get('slides').forEach((scene: Immutable.Map<string, unknown>, i: number) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
        });
    },
    migrateScene(scene) {
        return scene.withMutations((map) => {
            const children = map.get('children') as Immutable.List<unknown> | undefined;
            if (children) {
                children.forEach((_child: unknown, cIndex: number) => {
                    setIsEditableForColorAsset(map, ['children', cIndex]);
                });
            }

            const subslides = map.get('subslides') as Immutable.List<unknown> | undefined;
            if (!subslides) {
                return;
            }

            subslides.forEach((_subslide: unknown, sIndex: number) => {
                const subslide = map.getIn(['subslides', sIndex]) as
                    | Immutable.Map<string, unknown>
                    | undefined;
                if (!subslide) {
                    return;
                }

                const subslideChildren = subslide.get('children') as
                    | Immutable.List<unknown>
                    | undefined;
                if (!subslideChildren) {
                    return;
                }

                subslideChildren.forEach((_child: unknown, cIndex: number) => {
                    setIsEditableForColorAsset(map, ['subslides', sIndex, 'children', cIndex]);
                });
            });
        });
    },
});
